import { Clock, Mail, MapPin, Phone } from "lucide-react";
import { COMPANY } from "@/data";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-slate-800 bg-slate-950 text-slate-300">
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
        <p className="font-serif text-5xl font-semibold tracking-tight text-white sm:text-7xl">
          {COMPANY.name} <span className="text-sky-500">Witten</span>
        </p>
        <p className="mt-2 font-mono text-xs uppercase tracking-[0.25em] text-slate-500">
          {COMPANY.tagline} · {COMPANY.founded}
        </p>

        <div className="mt-14 grid grid-cols-1 gap-10 border-t border-slate-800/80 pt-10 sm:grid-cols-2 lg:grid-cols-4">
          <div>
            <h3 className="font-mono text-xs uppercase tracking-[0.2em] text-slate-500">Navigation</h3>
            <ul className="mt-4 space-y-2.5 text-sm">
              {[
                ["#start", "Start"],
                ["#leistungen", "Leistungen"],
                ["#ueber-uns", "Über uns"],
                ["#preise", "Preise"],
                ["#galerie", "Galerie"],
                ["#kontakt", "Kontakt"],
              ].map(([href, label]) => (
                <li key={href}>
                  <a href={href} data-testid={`footer-link-${label.toLowerCase().replace("ü", "ue")}`} className="transition-colors hover:text-white">
                    {label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h3 className="font-mono text-xs uppercase tracking-[0.2em] text-slate-500">Kontakt</h3>
            <ul className="mt-4 space-y-3 text-sm">
              <li className="flex items-center gap-2.5">
                <Phone className="h-4 w-4 text-sky-500" />
                <a href={COMPANY.phoneHref} data-testid="footer-phone" className="hover:text-white">{COMPANY.phone}</a>
              </li>
              <li className="flex items-center gap-2.5">
                <Mail className="h-4 w-4 text-sky-500" />
                <a href={COMPANY.emailHref} data-testid="footer-email" className="hover:text-white">{COMPANY.email}</a>
              </li>
              <li className="flex items-start gap-2.5">
                <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-sky-500" />
                <span>{COMPANY.street}, {COMPANY.city}<br />Einsatzgebiet: {COMPANY.region}</span>
              </li>
              <li className="text-sm text-slate-400">Inhaber: {COMPANY.owner} · {COMPANY.legalForm}</li>
            </ul>
          </div>
          <div>
            <h3 className="font-mono text-xs uppercase tracking-[0.2em] text-slate-500">Öffnungszeiten</h3>
            <p className="mt-4 flex items-start gap-2.5 text-sm">
              <Clock className="mt-0.5 h-4 w-4 shrink-0 text-sky-500" />
              {COMPANY.hours}
            </p>
            <p className="mt-4 text-sm text-slate-400">
              Auch kurzfristige Termine möglich.
            </p>
          </div>
          <div>
            <h3 className="font-mono text-xs uppercase tracking-[0.2em] text-slate-500">Rechtliches</h3>
            <ul className="mt-4 space-y-2.5 text-sm">
              <li><a href="/impressum" data-testid="footer-link-impressum" className="hover:text-white">Impressum</a></li>
              <li><a href="/datenschutz" data-testid="footer-link-datenschutz" className="hover:text-white">Datenschutz</a></li>
            </ul>
          </div>
        </div>

        <div className="mt-14 flex flex-col items-start justify-between gap-3 border-t border-slate-800/80 pt-6 text-xs text-slate-500 sm:flex-row sm:items-center">
          <p>© {new Date().getFullYear()} {COMPANY.fullName} · Inhaber {COMPANY.owner} · {COMPANY.legalForm}</p>
          <p className="font-mono uppercase tracking-[0.2em]">Streifenfrei. Garantiert.</p>
        </div>
      </div>
    </footer>
  );
}
